import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { findProductFromProductId } from "@qgiv/p2p-registration";
import { selectAllProducts } from "../../../../redux/slices/productsSlice";
import { selectCurrentProductId } from "../../../../redux/slices/productModalSlice";
import { selectCmsControlByType } from "../../../../redux/slices/cmsSettingsSlice";
import ProductDescription from "./ProductDescription";

const ConnectedProductDescription = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_STORE_PRODUCTS },
        },
    } = constants;

    const currentProductId = useSelector(selectCurrentProductId);
    const products = useSelector(selectAllProducts);

    const product = findProductFromProductId(currentProductId, products);
    const { description } = product;

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_STORE_PRODUCTS, state),
    );
    const {
        options: {
            productDescriptionHeading = "Details",
            showLessLink = "Show less",
            showMoreLink = "Show more",
        },
    } = control;

    const productDescriptionProps = {
        description,
        productDescriptionHeading,
        showLessLink,
        showMoreLink,
    };
    return <ProductDescription {...productDescriptionProps} />;
};

export default ConnectedProductDescription;
